import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullseye } from '@fortawesome/pro-light-svg-icons/faBullseye';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../music24/components/primitives/SMLButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from './SMLTrackers.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackersEmptyStateProps {
  onAdd: () => void;
}

/** Says what to paste. The old screen said only "+". */
const TrackersEmptyStateComponent: React.FC<TrackersEmptyStateProps> = ({ onAdd }) => {
  const intl = useIntl();

  return (
    <div className={styles.empty}>
      <span className={styles.emptyIcon}>
        <FontAwesomeIcon icon={faBullseye} />
      </span>
      <h4 className={styles.emptyTitle}>
        {intl.formatMessage({ id: 'app.sml.trackers.empty.title', defaultMessage: 'No trackers yet' })}
      </h4>
      <p className={styles.emptyText}>
        {intl.formatMessage({
          id: 'app.sml.trackers.empty.help',
          defaultMessage:
            'Paste a snippet from Facebook Pixel, Google Analytics or Plausible and it goes on every smartlink page you have.',
        })}
      </p>
      <SMLButton variant="primary" icon={<FontAwesomeIcon icon={faPlus} />} onClick={onAdd}>
        {intl.formatMessage({ id: 'app.sml.trackers.add', defaultMessage: 'Add tracker' })}
      </SMLButton>
    </div>
  );
};

export const TrackersEmptyState = TypedMemo(TrackersEmptyStateComponent);
